import styled from "styled-components";

export const Container = styled.div`
    background: #fff;
    padding: 10px;
    box-sizing: border-box;
    width:98%;
    margin: auto auto;
`